// import React from 'react';
// import Profile from '../features/auth/Profile';
// import Button from '../components/Button/Button';
// import { useAppDispatch } from '../app/hooks';
// import { logout } from '../features/auth/authSlice';
// import { useNavigate } from 'react-router-dom';

// const HomePage: React.FC = () => {
//   const dispatch = useAppDispatch();
//   const navigate = useNavigate();

//   const handleLogout = () => {
//     dispatch(logout());
//     navigate('/login');
//   };

//   return (
//     <div>
//       <Profile />
//       <Button onClick={handleLogout}>Logout</Button>
//     </div>
//   );
// };

// export default HomePage;
import React from 'react';
import Profile from '../../features/auth/Profile';
import Button from '../../components/Super Admin/Button/Button';
import { useAppDispatch } from '../../app/hooks';
import { logout } from '../../features/auth/authSlice';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react'; // <-- Import useMsal hook

const HomePage: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { instance } = useMsal(); // <-- Get the MSAL instance

  const handleLogout = async () => {
    try {
      await instance.logoutRedirect(); // <-- Call MSAL's logout method
      dispatch(logout()); // <-- Clear the Redux state
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <div>
      <Profile />
      <Button onClick={handleLogout}>Logout</Button>
    </div>
  );
};

export default HomePage;